import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderby',
    standalone: false
})
export class OrderByPipe implements PipeTransform {
  transform(array:Array<any>, args?) {
    // Check if array exists, in this case array contains articles and args is an array that has 1 element : !id
    if(array) {
      // get the first element
      let orderByValue = args[0];
      let timestamp = args[1];
      let byVal = 1;

      // check if exclamation point 
      if(orderByValue.charAt(0) == "!") {
        // reverse the array
        byVal = -1;
        orderByValue = orderByValue.substring(1)
      }

      array.sort((a: any, b: any) => {
        var aVal = this.getValue(a, orderByValue);
        var bVal = this.getValue(b, orderByValue);


        //special cases for __analytics.lastAccessed
        if(orderByValue.endsWith(".lastAccessed")) {
          let aTimeArr = this.getTimeArray( aVal, timestamp);
          let bTimeArr = this.getTimeArray( bVal, timestamp);
          
          if( aTimeArr[0] < bTimeArr[0] ) return -1*byVal;
          else if( aTimeArr[0] > bTimeArr[0] ) return 1*byVal;
          else {
            if(aTimeArr[1] < bTimeArr[1]) return -1*byVal;
            if(aTimeArr[1] > bTimeArr[1]) return 1*byVal;
            else {
              return this.breakEquality(a, b);
            }
          }
        } else { // else not required, but still added 

          if (typeof aVal === "string") {
            aVal = aVal.toLowerCase();
          }
          if (typeof bVal === "string") {
            bVal = bVal.toLowerCase()
          }
          if(orderByValue.indexOf("__analytics") != -1) {
            if (aVal === undefined) {
              aVal = -1;
            }
            if (bVal === undefined) {
              bVal = -1;
            }
          }
          // NEMO-1119 #1077 - Sort based on number of minutes as its the smallest unit of time displayed in UI
          if(orderByValue.endsWith(".ts")) {
            if (aVal > 0) {
              aVal = Math.floor(aVal/ (60 * 1000));
            }
            if (bVal > 0) {
              bVal = Math.floor(bVal/ (60 * 1000));
            }
          }
          if(aVal < bVal) {
            return -1*byVal;
          } else if (aVal > bVal) {
            return 1*byVal;
          } else {
            if (orderByValue.endsWith(".itemsCount.all") || orderByValue.endsWith(".aggregateGradeBest") || orderByValue.endsWith(".ts") 
              || ['meta.ln', 'meta.fn'].indexOf(orderByValue)!== -1) {
              return this.breakEquality(a, b);
            }
            if (orderByValue === 'last_name') {
              var aLFirstNameVal = a.first_name.toLowerCase();
              var bLFirstNameVal = b.first_name.toLowerCase();
              if(aLFirstNameVal < bLFirstNameVal) {
                  return -1;
              } else if (aLFirstNameVal > bLFirstNameVal) {
                  return 1;
              } else {
                return 0;
              }
            }
            if (orderByValue === 'duedate') {
              var aStartDate = a.startdate;
              var bStartDate = b.startdate;
              //For assignments sorting, if same due date then sorting assignments with created date descending order.
              if(aStartDate < bStartDate) {
                  return 1;
              } else if (aStartDate > bStartDate) {
                  return -1;
              } else {
                return 0;
              }
            }
            return 0;
          }

        }
      });
      return array;
    }
  }
  getValue(jsonObj, key) {
      //Fix for undefined error if user doesnt have rights to the product
      return key.split(".").reduce((a,curr) => a  && a[curr] ?  a[curr] : undefined, jsonObj);
  }

  // returns ['sec':1/'min':2/'hour':3/'day':4/'month':5, val ]
  getTimeArray(lastAccessedTimeStamp, currentTimeStamp){
    if(!lastAccessedTimeStamp) return [0];

    let lastAccessed = new Date(lastAccessedTimeStamp);
    let totalTimeInSeconds = Math.floor((currentTimeStamp - lastAccessed.getTime()) / 1000);

    if ( (totalTimeInSeconds / (3600 * 24)) >= 30 ){ //months
      return [ 5, Math.floor(totalTimeInSeconds / (3600 * 24 * 30)) ]; 
    } else if( (totalTimeInSeconds/(3600 * 24))>=1){ //days
      return [ 4, Math.floor(totalTimeInSeconds / (3600 * 24)) ]
    } else if( (totalTimeInSeconds / 3600) >= 1 ) { //hours
      return [ 3, Math.floor(totalTimeInSeconds / 3600) ];
    } else if( (totalTimeInSeconds/60) >=1 ){ //mins
      return [ 2, Math.floor(totalTimeInSeconds/60)];
    } else{ //secs
      return [ 1, Math.floor(totalTimeInSeconds) ];
    }
  }

  // break Equality from lastname and firstname 
  breakEquality(a, b){
    var aLastNameVal = a.meta.ln.toLowerCase();
    var bLastNameVal = b.meta.ln.toLowerCase();
    if(aLastNameVal < bLastNameVal) {
        return -1;
    } else if (aLastNameVal > bLastNameVal) {
        return 1;
    } else {
      var aLFirstNameVal = a.meta.fn.toLowerCase();
      var bLFirstNameVal = b.meta.fn.toLowerCase();
      if(aLFirstNameVal < bLFirstNameVal) {
          return -1;
      } else if (aLFirstNameVal > bLFirstNameVal) {
          return 1;
      } else {
        return 0;
      }
    }
  }
}